module.exports = __webpack_public_path__ + "img/souls-banner.30e847be.jpg";